import * as Sentry from '@sentry/react';
import { Dedupe } from '@sentry/integrations';
import { BrowserTracing } from '@sentry/tracing';
import { sentryDsn } from '../constants/AppConstants';
import { version } from '../../package.json';

Sentry.init({
  dsn: sentryDsn,
  maxBreadcrumbs: 10,
  attachStacktrace: true,
  tracesSampleRate: 0.01,
  integrations: [
    new Dedupe(),
    new BrowserTracing({
      tracingOrigins: ['*'],
    }),
  ],
  environment: process.env.REACT_APP_ENV,
  release: version,
});

export const captureException = err => {
  Sentry.configureScope(scope => {
    if (err.statusCode) scope.setExtra('statusCode', err.statusCode);
    scope.setExtra('query', window.location.search);
    scope.setExtra('pathname', window.location.pathname);
  });
  return Sentry.captureException(err);
};

export default Sentry;
